import React from "react";
import { AlertTriangle } from "lucide-react";

export const isAog = (s) => s?.pre_alert?.priority === "AOG";

export const AogTag = ({ s, testid }) => (isAog(s) ? (
  <span data-testid={testid} title="Aircraft on Ground: handle first"
        className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest px-1.5 py-0.5 rounded bg-rose-600 text-white shadow-[0_0_10px_rgba(225,29,72,0.45)]">
    <AlertTriangle size={10} /> AOG
  </span>
) : null);
